/** Фишки моделей с оценкой цены: отметить, чем генерировать. Без discovery модель недоступна. */
import { Chip } from "@/components/trends/ui";
import { estimateText, type ModelInfo } from "@/lib/persona";

/** Начальный выбор: `default` и discovered — или только `only` (режим итерации). */
export function defaultChosen(models: ModelInfo[], only?: string): Record<string, boolean> {
  return Object.fromEntries(
    models.map((m) => [m.code, only !== undefined ? m.code === only && m.discovered : m.default && m.discovered]),
  );
}

export function ModelChips({
  models,
  value,
  onChange,
}: {
  models: ModelInfo[];
  value: Record<string, boolean>;
  onChange: (next: Record<string, boolean>) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {models.map((m) => {
        const off = !m.discovered;
        const title = off ? `нет discovery: reels-runner imagegen discover --model ${m.code}` : (m.note ?? m.code);
        return (
          <span key={m.code} className={off ? "opacity-50" : undefined}>
            <Chip
              on={!off && value[m.code] === true}
              title={title}
              onClick={() => {
                if (!off) onChange({ ...value, [m.code]: !value[m.code] });
              }}
            >
              {m.note && !off ? (
                <span className="mr-1 inline-block size-1.5 rounded-full bg-fg-faint align-middle" />
              ) : null}
              {m.label}
              {m.estimate !== undefined ? (
                <span className="ml-1.5 text-fg-faint tnum">
                  {estimateText(m.estimate, m.estimate_source ?? "spike")}{" "}
                  {m.estimate_source === "fact" ? "факт" : "спайк"}
                </span>
              ) : null}
            </Chip>
          </span>
        );
      })}
    </div>
  );
}
